import { Component, OnInit, ViewChild } from '@angular/core';
import {  ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';

@Component({
  selector: 'app-targets',
  templateUrl: './targets.component.html',
  styleUrls: ['./targets.component.css'],
  providers: [ MessageService,ConfirmationService]
})
export class TargetsComponent implements OnInit {


  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Update target list'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/surveys/target-edit/update',data.data.id]);
      }   
    },
    { field: 'id',  
    headerName: '', 
    maxWidth:140,
    cellRenderer: params =>    {   
        if(typeof params.value == 'undefined')
          return '';
        return '<a style="cursor:pointer;color:blue;" title="">Emails not sent</a>'; 
      },
      onCellClicked:function(data){ 
        console.log(data);
          _this.router.navigate(['/dashboard/surveys/surveys-emailsnotsent',data.data.id]);
      }   
    },
    { field: 'name',headerName: 'Name' },
    { field: 'total_target',headerName: 'Total targets' },
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
        
            
     
          return '<a title="'+'Delete targets list'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 
    
        if(typeof params.value == 'undefined')
        return '';
        
        _this.confirmationService.confirm({
          message: 'Attention: do you confirm the delete of the target list?',
          accept: () => {
            _this.apiService.deleteTarget({id:params.data.id}).subscribe(data => {
              _this.addSingle('success', 'Success', 'Target deleted');
              _this.load();
            });
          }
        });
      },
    },
  ];
  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  targetslist: any[] = [];
  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
  ) { }

  
  ngOnInit(): void {
    _this=this;
    this.load();
   
  }

  load(){
    const params: any = {PageSize : 10000};
    this.apiService.get('surveys-targets/listall',params).subscribe(data => {
      this.targetslist=data.Result;
      });
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


}
var _this;